import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Hammer = createSvgIcon(
  <path d="M7.875 0H6.75v1.5H0v9h6.75V12h1.5v12h2.25V12h3v12h2.25V12h1.5V9.75H24V8.625c0-1.808-1.24-3.993-3.787-5.673C17.637 1.252 13.654 0 7.875 0ZM15 9.75H9V2.267c4.833.15 8.011 1.267 9.974 2.563 1.374.906 2.128 1.876 2.491 2.67H15v2.25Zm-8.25-1.5h-4.5v-4.5h4.5v4.5Z" />,
  'Hammer'
);

export { Hammer };